import Actions    from "../model/constant/actions"

export const ScreenSize = () => {
  return {type:Actions.PROVIDE_SCREEN_SIZE}
}
